export default __webpack_public_path__ + "static/media/22-460x460.0000705c.jpeg";